module.exports = __webpack_public_path__ + "img/telegrm.f58aaa27.svg";